import { Controller } from "@hotwired/stimulus"

// Party step (subscriber, beneficiary) of an amendment: one pane per party type, each preloaded in
// its own turbo frame when the step opens. Switching only toggles visibility, so it is instant
// instead of reloading the step. Each pane carries its own form, so the hidden ones are never submitted.
export default class extends Controller {
  static targets = ["choice", "pane", "label"]

  switch() {
    const selected = this.choiceTargets.find((input) => input.checked)?.value

    this.paneTargets.forEach((pane) => {
      pane.classList.toggle("d-none", pane.dataset.partyType !== selected)
    })

    // The labels keep the historical look (primary for the active type, link for the others), which
    // Bootstrap's :checked styling only handles for btn-outline-*.
    this.labelTargets.forEach((label) => {
      const active = label.dataset.partyType === selected
      label.classList.toggle("btn-primary", active)
      label.classList.toggle("btn-link", !active)
      label.classList.toggle("bg-shadow", !active)
    })
  }
}
